import { atom, selector } from "recoil";
import { customerConfigState } from "./CustomerConfigState";

export const coPilotDisplaySettingsSelector = selector({
  key: 'coPilotDisplaySettingsSelector',
  get: ({get}) => {
    const customerConfig = get(customerConfigState);
    const settings = customerConfig['copilotDisplaySettings'];
    if (settings) {
      return settings;
    }

    return {
      iconSize: 30,
      label: 'code',
      labelTextSize: 30,
      list: 'code',
      alertNotification: false,
      cessnaIconAlert: "red",
      cessnaIconNormal: "blue",
      cessnaLabelBGColor: "rgba(0, 0, 255, 0.7)",
      cessnaLabelTextColor: "#FFFFFF",
      heliIconAlert: "red",
      heliIconNormal: "blue",
      heliLabelBGColor: "rgba(0, 0, 255, 0.7)",
      heliLabelTextColor: "#FFFFFF",
      naviIconAlert: "red",
      naviIconNormal: "blue",
      naviLabelBGColor: "rgba(0, 0, 255, 0.7)",
      naviLabelTextColor: "#FFFFFF",
      otherCompanyIconAlert: "red",
      otherCompanyIconNormal: "blue",
      otherCompanyLabelBGColor: "rgba(0, 0, 255, 0.7)",
      otherCompanyLabelTextColor: "#FFFFFF",
      otherIconAlert: "red",
      otherIconNormal: "blue",
      otherLabelBGColor: "rgba(0, 0, 255, 0.7)",
      otherLabelTextColor: "#FFFFFF"
    };
  },
  set: ({set, get}, settings) => {
    const customerConfig = get(customerConfigState);
    const newCustomerConfig = {...customerConfig, ...{copilotDisplaySettings: settings, update: true}};
    set(customerConfigState, newCustomerConfig);
  }
});

export const audioContextState = atom({
  key: 'audioContextState',
  default: null
});
